function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { UnstyledTableBodyNoDataWrapper } from "../../../../unstyled";
/*
    Wraps the Table Body to show a message below the body when there are no rows

    props
        (jsx, optional)  noDataMessage  The content to show when there are no rows
*/

const TableBodyNoDataWrapper = ({
  classPrepend = "styled",
  noDataMessage = "No data available",
  rows = [],
  children,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(UnstyledTableBodyNoDataWrapper, _extends({
    classPrepend: classPrepend,
    noDataMessage: noDataMessage,
    rows: rows,
    children: children
  }, rest));
};
export { TableBodyNoDataWrapper };